import React from 'react'

import { Breadcrumbs } from '@hhgtech/hhg-components'
import { SectionContainerStyled } from 'components/atoms/container/index.styled'
import FormatInnerHTML from 'components/atoms/FormatInnterHTML'
import { domainLocales } from 'domainLocales'
import { useRouter } from 'next/router'
import HomeIcon from 'public/svg/home.svg'
import styled from 'styled-components'

const WrapperBreadcrumbStyled = styled(SectionContainerStyled)`
  .breadcrumb-marry-baby div {
    &,
    & > a {
      display: flex;
      align-items: center;
    }
  }
`

export interface IBreadcrumb {
  label: string | JSX.Element
  value: string
  active?: boolean
  dataEventCategory?: string
  dataEventAction?: string
  dataEventLabel?: string
}

export type IBreadcrumbMarryBaby = {
  pages: IBreadcrumb[]
  className?: string
}

const BreadcrumbMarryBaby = (props: IBreadcrumbMarryBaby) => {
  const { pages, className, ...others } = props
  const { locale } = useRouter() || {}
  const sL = locale || 'vi-VN' // standardized locale
  const icon = <HomeIcon />

  const breadcrumbs = pages.map(
    (breadcrumb: IBreadcrumb, index: number, arr: IBreadcrumb[]) => ({
      ...breadcrumb,
      active: index === arr.length - 1,
    }),
  )

  return (
    <WrapperBreadcrumbStyled className="bread-crumbs">
      <Breadcrumbs
        size="sm"
        className={`breadcrumb-marry-baby ${className || ''}`}
        separator={<FormatInnerHTML template="&nbsp;/&nbsp;" />}
        pages={[
          {
            label: icon,
            value: '/',
            active: false,
            dataEventCategory: 'Breadcrumb',
            dataEventAction: 'Click',
            dataEventLabel: `https://${domainLocales[sL]}`,
          },
          ...breadcrumbs,
        ]}
        {...others}
      />
    </WrapperBreadcrumbStyled>
  )
}

export default BreadcrumbMarryBaby
